<div class="modal-overlay" (click)="close()"></div>
<div class="modal-content">
  <div class="modal-header">
    <h3 class="m-0">User Manual</h3>
    <mat-icon class="close-icon" (click)="close()">close</mat-icon>
  </div>

  <div mat-dialog-content>
    <div *ngIf="loading" class="loading-spinner">
      <mat-spinner></mat-spinner>
    </div>

    <ng-container *ngIf="!loading">
      <ng-container *ngIf="data.type == 'doc_path'; else videoContent">
        <iframe *ngIf="sanitizedUrl" [src]="sanitizedUrl" class="video-player" frameborder="0"></iframe>
      </ng-container>

      <ng-template #videoContent>
        <video *ngIf="sanitizedUrl" controls class="video-player">
          <source [src]="sanitizedUrl" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </ng-template>
    </ng-container>
  </div>


</div>